const Designation = {

    // FIELDS
    "designation_name": "Designation Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "designation": "Designation",

    // ERROR
    "error_name": "Enter Designation Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": "DESIGNATION NAME",
    "table_status": "STATUS",

}

export default Designation;
